import { useState } from 'react';
import { PageTitle } from '@presentation/components/common/PagesTitle';

import './LoginPage.css';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '@presentation/context/AuthContext';
import { routes } from '@presentation/router/routes';
import { Form } from '@/presentation/components/Forms/Form/Form';



export default function LoginPage() {
  const navigate = useNavigate();
  const { login, isLoading } = useAuthContext();

  
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmitValues = async (
    values: Record<string, unknown>
  ) => {

    setErrorMessage('');

    try {
      const result = await login(String(values.mail), String(values.pass));
      console.log(result)

      if (result.success == false) {
        navigate(routes.newLogin, {
          replace: true,
          state: {
            user: result.user,
          },
        });

        return;
      }

      navigate(routes.dashboard, { replace: true });
    } catch (error) {
      console.error(error);
      setErrorMessage('Usuario o contraseña incorrectos');
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">

        <img
          src="/logo.png"
          alt="Logo"
          className="logo"
        />

        <PageTitle title="Sistema de Incidentes" />

        <Form
          fields={[
            {
              name:'mail',
              label: 'Correo Electrónico',
              type:'email',
            },
            {
              name:'pass',
              label: 'Contraseña',
              type:'password'
            },
          ]}


          
          submitLabel={
            isLoading
              ? 'Iniciando'
              : 'Iniciar Sesión'
          }
          onSubmit={handleSubmitValues}

        />

        
        {
          errorMessage && (
            <div className="error">
              {errorMessage}
            </div>
          )
        }

      </div>
    </div>
  );
}